class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]',
      ),
      panel: this.querySelector("ul"),
    };
    this.modal = this.querySelector(".localization-modal");
    this.searchInput = this.querySelector(
      "#localization-search, .localization-search",
    );
    this.countryItems = this.querySelectorAll(
      ".disclosure__item:not(.localization-no-results)",
    );
    this.noResults = this.querySelector(".localization-no-results");

    this.setupSearch();
    this.setupClickInteraction();
    this.setupModalObserver();
  }

  setupSearch() {
    if (!this.searchInput) return;

    this.searchInput.addEventListener("input", this.onSearchInput.bind(this));
    this.searchInput.addEventListener("search", this.onSearchInput.bind(this));
    this.searchInput.addEventListener(
      "keydown",
      this.onSearchKeyDown.bind(this),
    );
  }

  onSearchInput() {
    if (!this.searchInput) return;
    const query = this.searchInput.value.trim().toLowerCase();
    let visibleCount = 0;

    this.countryItems.forEach((item) => {
      const name =
        item.getAttribute("data-country-name") ||
        item.textContent.toLowerCase();
      const code = item.getAttribute("data-country-code") || "";
      const currencyCode = item.getAttribute("data-currency-code") || "";
      const currencySymbol = item.getAttribute("data-currency-symbol") || "";
      const matches =
        !query ||
        name.includes(query) ||
        code.includes(query) ||
        currencyCode.includes(query) ||
        currencySymbol.includes(query);

      item.style.display = matches ? "" : "none";
      if (matches) visibleCount++;
    });

    if (this.noResults) {
      this.noResults.style.display = visibleCount === 0 ? "flex" : "none";
    }
  }

  onSearchKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const firstVisibleLink = Array.from(this.countryItems)
        .find((item) => item.style.display !== "none")
        ?.querySelector(".localization-contry-link");
      if (firstVisibleLink) {
        firstVisibleLink.click();
      }
    }
  }

  resetSearch() {
    if (this.searchInput && this.searchInput.value !== "") {
      this.searchInput.value = "";
      this.onSearchInput();
    }
  }

  focusSearchIfLaptop() {
    if (window.innerWidth >= 1024 && this.searchInput) {
      setTimeout(() => {
        if (this.modal?.classList.contains("active")) {
          this.searchInput.focus();
        }
      }, 50);
    }
  }

  setupModalObserver() {
    if (!this.modal) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isActive = this.modal.classList.contains("active");
          if (isActive) {
            this.focusSearchIfLaptop();
          } else {
            this.resetSearch();
          }
        }
      });
    });
    observer.observe(this.modal, { attributes: true });
  }

  setupClickInteraction() {
    const btn = document.getElementById("open-localization-modal");
    const mobileBtn = document.querySelector(".currency-btn");
    const modal = this.modal;

    if (!modal) return;

    const positionModal = () => {
      if (window.innerWidth > 767 && btn && btn.offsetParent !== null) {
        const rect = btn.getBoundingClientRect();
        modal.style.top = `${rect.bottom + 5}px`;
        modal.style.left = `${rect.left + rect.width / 2}px`;
      } else {
        modal.style.top = "";
        modal.style.left = "";
      }
    };

    const showModal = (e) => {
      if (e) e.preventDefault();
      positionModal();
      modal.classList.add("active");
      if (btn) btn.setAttribute("aria-expanded", "true");
      if (mobileBtn) mobileBtn.setAttribute("aria-expanded", "true");
      this.focusSearchIfLaptop();
    };

    const hideModal = () => {
      modal.classList.remove("active");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (mobileBtn) mobileBtn.setAttribute("aria-expanded", "false");
      this.resetSearch();
    };

    const toggleModal = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (modal.classList.contains("active")) {
        hideModal();
      } else {
        showModal();
      }
    };

    if (btn) {
      btn.addEventListener("click", toggleModal);
    }

    if (mobileBtn) {
      mobileBtn.addEventListener("click", toggleModal);
    }

    const closeBtn = document.getElementById("close-localization-modal");
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideModal();
        if (btn) btn.focus();
      });
    }

    // Close modal when clicking outside
    document.addEventListener("click", (e) => {
      if (!modal.classList.contains("active")) return;
      if (modal.contains(e.target)) return;
      if (mobileBtn && mobileBtn.contains(e.target)) return;
      if (btn && btn.contains(e.target)) return;

      hideModal();
    });

    // Close modal on Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        if (modal.classList.contains("active")) {
          hideModal();
          if (btn) btn.focus();
        }
      }
    });

    // Reposition on window resize if open
    window.addEventListener("resize", () => {
      if (modal.classList.contains("active")) {
        positionModal();
      }
    });
  }

  hidePanel() {
    const modal = this.querySelector(".localization-modal");
    if (modal) modal.classList.remove("active");
    if (this.elements.panel) this.elements.panel.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    this.resetSearch();

    const openBtn = document.getElementById("open-localization-modal");
    if (openBtn) openBtn.setAttribute("aria-expanded", "false");
  }
}

customElements.define("localization-form", LocalizationForm);
